export enum ESaveClipStep {
  CHECKING = "CHECKING",
  SUMMARY = "SUMMARY",
  SUCCESS = "SUCCESS",
  NO_STORAGE = "NO_STORAGE",
  DELETE_BROWSE = "DELETE_BROWSE",
  DELETE_CONFIRM = "DELETE_CONFIRM",
  ERROR = "ERROR",
}

export interface ISaveClipModalData {
  clipId: string;
  clipTitle: string;
}

export interface IStorageStatus {
  savedCount: number;
  limit: number;
  hasSpace: boolean;
}

export type TSavedFilter = "all" | "saved" | "unsaved";

export type TSelectionMode = "save" | "unsave" | null;

export interface IClipTag {
  key: string;
  value: string;
}

export interface IClipForDeletion {
  id: string;
  internalId: string;
  title: string;
  game: string;
  tags: IClipTag[];
  thumbnailUrl: string;
  views: number;
  score: number;
  createdAt: string;
  isSaved: boolean;
  saved?: {
    savedBy?: string[];
  };
}
